import toast from 'react-hot-toast';

export const ADD_TO_COMPARE = "ADD_TO_COMPARE";
export const REMOVE_FROM_COMPARE = "REMOVE_FROM_COMPARE";

// add to compare
export const addToCompare = (item) => {
  return dispatch => {
    toast.success("Added To Compare");
    dispatch({ type: ADD_TO_COMPARE, payload: item });
  };
};

// remove from compare
export const removeFromCompare = (item) => {
  return dispatch => {
    toast.error("Removed From Compare");
    dispatch({ type: REMOVE_FROM_COMPARE, payload: item });
  };
};
